// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation_bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    padding-right: 6px;
    margin-right: 6px;
    border-right: 1px solid var(--color-border);
}

.navigation_bar__btn {
    height: 38px;
    padding: 0 8px;
    background: none;
    border: none;
    color: var(--color-text-muted);
    font-size: 16px;
    cursor: pointer;
    line-height: 1;
}

.navigation_bar__btn:disabled {
    opacity: 0.3;
    cursor: default;
}

@media (pointer: fine) {
    .navigation_bar__btn:hover {
        color: var(--color-text);
        background-color: var(--color-bg-3);
    }
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/NavigationBar/s.navigation_bar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,wBAAwB;QACxB,mCAAmC;IACvC;AACJ","sourcesContent":[".navigation_bar {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-shrink: 0;\n    padding-right: 6px;\n    margin-right: 6px;\n    border-right: 1px solid var(--color-border);\n}\n\n.navigation_bar__btn {\n    height: 38px;\n    padding: 0 8px;\n    background: none;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 16px;\n    cursor: pointer;\n    line-height: 1;\n}\n\n.navigation_bar__btn:disabled {\n    opacity: 0.3;\n    cursor: default;\n}\n\n@media (pointer: fine) {\n    .navigation_bar__btn:hover {\n        color: var(--color-text);\n        background-color: var(--color-bg-3);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
